import _ from "lodash";

function isIntercomWebLoaded(): boolean {
  return typeof window !== "undefined" && window.Intercom && _.isFunction(window.Intercom);
}

export function sendUpdateRequestToIntercom(settings?: Intercom_.IntercomSettings): void {
  if (isIntercomWebLoaded()) {
    if (settings) {
      // NOTE: Any styles passed are ignored on mobile web
      window.Intercom("update", settings);
    } else {
      window.Intercom("update");
    }
  }
}

export function sendShutdownRequestToIntercom(): void {
  if (isIntercomWebLoaded()) {
    window.Intercom("shutdown");
  }
}
